import { useEffect, useState } from "react";

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 400);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!visible) return null;

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-6 right-6 z-50 w-12 h-12 rounded-full bg-accent-500 text-background-50 shadow-lg hover:bg-accent-600 transition-all flex items-center justify-center"
      aria-label="Scroll to top"
    >
      <div className="w-5 h-5 flex items-center justify-center">
        <i className="ri-arrow-up-line text-lg" />
      </div>
    </button>
  );
}